// PermutationRaceTask.js
// Permutacje bez powtórzeń — zawodnicy w biegu / osoby w kolejce

import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

function fact(n) {
  let r = 1;
  for (let i = 2; i <= n; i++) r *= i;
  return r;
}

// ==== GENERATOR ====
// Losujemy liczbę osób z przedziału 3–10
// Losujemy scenariusz: "race" (bieg) albo "queue" (kolejka)
export function generateTask() {
  const n = Math.floor(Math.random() * 8) + 3; // 3..10
  const scenario = Math.random() < 0.5 ? "race" : "queue";
  const answer = fact(n);

  return {
    type: "PermutationRaceTask",
    data: { n, scenario, answer },
  };
}

// ==== RENDER ====
export function renderTask({ data }) {
  const { n, scenario } = data;

  if (scenario === "queue") {
    return (
      <div style={{ textAlign: "left" }}>
        <p>
          Do kasy ustawia się <InlineMath math={`${n}`} /> osób.
          Na ile sposobów mogą ustawić się w kolejce?
        </p>
      </div>
    );
  }

  // race (domyślnie)
  return (
    <div style={{ textAlign: "left" }}>
      <p>
        W biegu startuje <InlineMath math={`${n}`} /> zawodników.
        Na ile sposobów mogą dobiec od mety?
      </p>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label=""
      placeholder="Wpisz liczbę sposobów"
    />
  );
}

// ==== LOGIKA ODP ====
export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") {
    return { correct: false, message: "Podaj liczbę." };
  }
  const given = parseInt(userAnswer.raw, 10);
  if (Number.isNaN(given)) {
    return { correct: false, message: "Podaj liczbę całkowitą." };
  }

  const correct = given === data.answer;
  userAnswer.correctAnswer = data.answer;

  return { correct, message: correct ? "Dobrze!" : "Spróbuj ponownie." };
}

export function renderAnswer({ data }) {
  return <InlineMath math={`${data.answer}`} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={`${userAnswer.raw}`} />;
}

// ==== WYJAŚNIENIE ====
export function renderExplanation({ data }) {
  const { n, scenario, answer } = data;
  const terms = Array.from({ length: n }, (_, i) => n - i).join(" \\cdot ");

  const intro =
    scenario === "queue"
      ? "W kolejce każda kolejność osób jest inna."
      : "Wynik biegu to kolejność zawodników na mecie.";

  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1.</strong> {intro}
      </p>

      <p>
        <strong>Krok 2.</strong> Wybieramy kolejno osoby/zawodników:
      </p>

      <p>
        <InlineMath math={`${n}`} /> możliwości na 1. miejscu,{" "}
        <InlineMath math={`${n - 1}`} /> na 2. miejscu, itd.
      </p>

      <p>
        <strong>Krok 3.</strong> Zasada mnożenia:
      </p>
      <BlockMath math={`${terms} = ${n}! = ${answer}`} />
    </div>
  );
}
